import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from 'context/config';

const Container = styled('div')`
  background-color: ${({ theme }) => theme.palette.primary.main};
  height: 100vh;
  font-size: 22px;
  color: #fff;
  font-weight: 400;
  text-align: center;
  overflow: hidden;
  h1 {
    color: #fff;
    font-size: 10vw;
    font-weight: 800;
    margin-bottom: 20px;
  }
  .logo {
    width: 200px;
    margin: 1rem auto;
  }
`;

export default ({}) => {
  const config = useContext(ConfigContext);
  const [t] = useTranslation();
  return (
    <Container>
      <h1>404</h1>
      <Typography color="inherit" variant="subtitle1">
        {t(
          'page-not-found',
          `Oops, the page you're looking for does not exist.`,
        )}
      </Typography>
      <Link href="/">
        <div className="logo">
          <img
            src={`/assets/images/${
              config.BRAND === 'TMG' ? 'tmg-logo-white.png' : 'logo.svg'
            }`}
            alt="logo"
            className="logo"
          />
        </div>
      </Link>
    </Container>
  );
};
